import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { ScheduleService } from 'src/app/shared/services/pay-schedules/schedule.service';

@Component({
  selector: 'app-delete-schedule',
  templateUrl: './delete-schedule.component.html',
  styleUrls: ['./delete-schedule.component.css']
})
export class DeleteScheduleComponent {
  msg = '';
  loading = false;
  result: any;
  @Input() scheduleId = 0;
  @Input() configText: any;
  @Output() closedeleteDialog = new EventEmitter();

  constructor(private scheduleService: ScheduleService,
    private notificationService: DisplayNotificationService) { }

  deleteSchedule(status: any): void {
    if (status === 'yes') {
      this.loading = true;
      const obj = { id: this.scheduleId, userInfo: this.scheduleService.UserInfo() };
      this.scheduleService.delete(obj)
        .subscribe((response) => {
          if (response) {
            this.closedeleteDialog.emit(response);
            if (response.success) {
              this.notificationService.setUpNotification(response);
            } else {
              this.notificationService.setErrorNotification(response.message);
            }
          } else {
            this.notificationService.setErrorNotification();
          }
          this.loading = false;
        },
          (err: HttpErrorResponse) => {
            console.log(err);
            this.loading = false;
            this.notificationService.setErrorNotification();
          });
    } else {
      this.closedeleteDialog.emit(false);
    }
  }
}
